import { useState } from 'react'
import { LoginFormImport } from './Imports'
const { RoutesMap, Form, InputGroup, Card, Button, useFormik, LoginSchema, useNavigate, useDispatch, toast, LuKeyRound, LuUser2, Logo, ButtonLoader, SessionManager, signInTodo, sidebarTodo } = LoginFormImport

export default function UserLoginForm(props) {

    const { setTogggle } = props

    const [spinner, setSpinner] = useState(false)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const initialValues = {
        user: '',
        password: '',
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: LoginSchema,

        onSubmit: (values, action) => {
            // console.log(values)
            setSpinner(true)
            dispatch(signInTodo(values)).then((res) => signIn_user(res.payload, action))
        },
    })

    const signIn_user = (res, action) => {

        if (res?.status === 200) {

            SessionManager.setCookie('user_token', `Bearer ${res.data.id_token}`, 3)

            dispatch(sidebarTodo({ navigate })).then((res1) => sidebar_res(res1.payload))

        } else if (res?.status === 400) {
            setSpinner(false)
            toast.error("Something went wrong!!..", { position: "bottom-right" })
        } else if (res?.status === 500) {
            setSpinner(false)
            toast.error("Server error!!..", { position: "bottom-right" })
        } else {
            setSpinner(false)
            toast.error("Something went wrong!!..", { position: "bottom-right" })
        }
    }

    const sidebar_res = (res) => {
        if (res?.status === 200) {
            const permission = res?.data?.actionAttribtes?.map(val => JSON.parse(val)).flat()
            SessionManager.setSession('permission', JSON.stringify(permission))
            SessionManager.setCookie('user', res?.data?.userDTO && JSON.stringify(res?.data?.userDTO), 3)

            toast.success("SignIn Successfully!!..", { position: "bottom-right" })
            SessionManager.setSession('lang_key', 'en')

            navigate(RoutesMap.DASHBOARD.path)
            setSpinner(false)
        } else if (res?.status === 400) {
            setSpinner(false)
            toast.error("Something went wrong!!..", { position: "bottom-right" })
        } else {
            setSpinner(false)
            toast.error("Something went wrong!!..", { position: "bottom-right" })
        }
    }

    return (
        <>
            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} className='h-100'>
                <Card className="h-100 rounded-start-5 rounded-end-0" style={{ backgroundColor: '#F8FAFC' }}>
                    <Card.Header className="p-3 text-end" style={{ backgroundColor: 'unset' }}>
                        <u className='fs-6 fw-medium' style={{ cursor: 'pointer' }} onClick={() => setTogggle(true)}>Forget Password?</u>
                    </Card.Header>
                    <Card.Body className='p-5 d-flex align-items-center'>
                        <div className='flex-fill'>
                            <img src={Logo} alt="logo" className='img-fluid' style={{ height: '100px' }} />
                            <div className='mt-3'>
                                <h3>Sign In to Continue</h3>
                                <p>Let's get started !!...</p>
                            </div>

                            <div className='mb-2'>
                                <Form.Label className='fw-medium mb-1' style={{ color: '#001529' }}>{'Username'}</Form.Label>
                                <InputGroup className="" size="sm">
                                    <InputGroup.Text id="basic-addon1"><LuUser2 /></InputGroup.Text>
                                    <Form.Control
                                        className='login-input'
                                        placeholder="Enter Your Username"
                                        aria-label="Username"
                                        aria-describedby="basic-addon1"
                                        name='user'
                                        value={values.user || ''}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                </InputGroup>
                                {errors.user && touched.user ? (<span className='field_error'>{errors.user}</span>) : null}
                            </div>

                            <div className='mb-2'>
                                <Form.Label className='fw-medium mb-1' style={{ color: '#001529' }}>{'Password'}</Form.Label>
                                <InputGroup className="" size="sm">
                                    <InputGroup.Text id="basic-addon1"><LuKeyRound /></InputGroup.Text>
                                    <Form.Control
                                        type='password'
                                        className='login-input'
                                        placeholder="Enter Your Password"
                                        aria-label="Password"
                                        aria-describedby="basic-addon1"
                                        name='password'
                                        value={values.password || ''}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                </InputGroup>
                                {errors.password && touched.password ? (<span className='field_error'>{errors.password}</span>) : null}
                            </div>
                        </div>
                    </Card.Body>
                    <Card.Footer className="text-muted d-flex justify-content-between align-items-center" style={{ backgroundColor: 'unset' }}>
                        <span style={{ fontSize: '13px' }} className=''>By continuing, you agree to the <u className='text-dark' style={{ cursor: 'pointer' }}>terms of service</u> and <u className='text-dark' style={{ cursor: 'pointer' }}>privacy policy</u>.</span>
                        <Button type='submit' size='sm' className='login_save_btn' disabled={spinner}>
                            {spinner ?
                                <ButtonLoader />
                                :
                                'Login'
                            }
                        </Button>
                    </Card.Footer>
                </Card>
            </Form>
        </>
    )
}